import { Component, Inject, Input, LOCALE_ID, OnChanges, SimpleChanges } from '@angular/core';
import { NumberSymbol, getLocaleNumberSymbol } from '@angular/common';

import { isNumber } from 'rev-shared/util';

import styles from './VbUiKpi.Component.module.less';

const ICON_DELTA_NEG: string = 'circle_arrow_down';
const ICON_DELTA_POS: string = 'circle_arrow_top';
const ICON_DELTA_ZERO: string = 'circle_arrow_right';

@Component({
	selector: 'vb-ui-kpi',
	templateUrl: './VbUiKpi.Component.html',
	host: {
		'[class]': 'subValue ? "width-full" : ""',
	},
	standalone: false
})
export class VbUiKpiComponent implements OnChanges {
	@Input() public decimalPlaces: number = 0;
	@Input() public hideChangeIndicators: boolean = false;
	@Input() public suffix: string = '';
	@Input() public reverseColors: boolean = false;
	@Input() public threshold: number;
	@Input() public subValueThreshold: number;
	@Input() public value: number;
	@Input() public valueLabel: string;
	@Input() public subValue: number;
	@Input() public subValueLabel: string;
	@Input() public thresholdRange: Array<number | null>;
	@Input() public reverseRange: boolean = false;
	@Input() public showZero: boolean = false;

	public delta: number;
	public subValueDelta: number;
	public readonly localeDecimalSymbol: string = getLocaleNumberSymbol(this.localeId, NumberSymbol.Decimal);
	public readonly localeGroupSymbol: string = getLocaleNumberSymbol(this.localeId, NumberSymbol.Group);
	public readonly styles = styles;

	constructor(
		@Inject(LOCALE_ID) private readonly localeId: string
	) {}

	public get deltaIconCssClass(): string {
		return this.getDeltaIconCssClass(this.value, this.delta);
	}

	public get subValueDeltaIconCssClass(): string {
		return this.getDeltaIconCssClass(this.subValue, this.subValueDelta);
	}

	private getDeltaIconCssClass(value: number, delta: number): string {
		const suffixClass = ` ${this.getThresholdRangeClass(value)}`;
		if (delta > 0) {
			return ICON_DELTA_POS + suffixClass;
		}

		if (delta < 0) {
			return ICON_DELTA_NEG + suffixClass;
		}

		return this.showZero ? (ICON_DELTA_ZERO + suffixClass) : '';
	}

	public ngOnChanges(changes: SimpleChanges): void {
		const isChange: boolean = !!(
			changes.threshold ||
			changes.value
		);

		const isSubValueChange: boolean = !!(
			changes.subValueThreshold ||
			changes.subValue
		);

		if (isChange && isNumber(this.value)) {
			this.delta = this.getDelta(changes.value?.previousValue, this.value, this.threshold);
		}

		if(isSubValueChange && isNumber(this.subValue)) {
			this.subValueDelta = this.getDelta(changes.subValue?.previousValue, this.subValue, this.subValueThreshold);
		}
	}

	private getDelta(previousValue: number, currentValue: number, threshold?: number): number {
		if (isNumber(threshold)) {
			return currentValue <= threshold ? 1 : -1;
		}

		return !this.hideChangeIndicators && isNumber(previousValue) ?
			currentValue - previousValue :
			0;
	}

	private getThresholdRangeClass(value) {
		if (isNumber(value) && this.thresholdRange) {
			if (value > this.thresholdRange[2]) {
				return this.reverseRange ? styles.valueBelowThreshold : styles.valueAboveThreshold;
			} else if (value > this.thresholdRange[1]) {
				return styles.valueBetweenThreshold;
			}
			return this.reverseRange ? styles.valueAboveThreshold : styles.valueBelowThreshold;

		}
		return '';
	}
}
